import CONFIG from "./config";

const API_ENDPOINT = {
  PREDICT: `${CONFIG.BASE_URL}/predict`,
};

export default API_ENDPOINT;